import type { SessionConfig } from "./BaseConnection.js";
import type { InitiationClientDataEvent } from "./events.js";
import { sourceInfo } from "../sourceInfo.js";

export const CONVERSATION_INITIATION_CLIENT_DATA_TYPE =
  "conversation_initiation_client_data";

export function constructOverrides(
  config: SessionConfig
): InitiationClientDataEvent {
  const overridesEvent: InitiationClientDataEvent = {
    type: CONVERSATION_INITIATION_CLIENT_DATA_TYPE,
  };

  if (config.overrides) {
    overridesEvent.conversation_config_override = {
      agent: {
        prompt: config.overrides.agent?.prompt,
        first_message: config.overrides.agent?.firstMessage,
        language: config.overrides.agent?.language,
      },
      tts: {
        voice_id: config.overrides.tts?.voiceId,
        speed: config.overrides.tts?.speed,
        stability: config.overrides.tts?.stability,
        similarity_boost: config.overrides.tts?.similarityBoost,
      },
      conversation: {
        text_only: config.overrides.conversation?.textOnly,
      },
    };
  }

  if (config.customLlmExtraBody) {
    overridesEvent.custom_llm_extra_body = config.customLlmExtraBody;
  }

  if (config.dynamicVariables) {
    overridesEvent.dynamic_variables = config.dynamicVariables;
  }

  if (config.userId) {
    overridesEvent.user_id = config.userId;
  }

  overridesEvent.source_info = {
    source: sourceInfo.name,
    version: sourceInfo.version,
  };

  if (config.toolMockConfig) {
    overridesEvent.tool_mock_config = {
      mocking_strategy: config.toolMockConfig.mockingStrategy,
      mocked_tool_names: config.toolMockConfig.mockedToolNames,
      fallback_strategy: config.toolMockConfig.fallbackStrategy,
    };
  }

  return overridesEvent;
}
